import { MessageSquare } from 'lucide-react';
import SmileCompareSlider from '../SmileCompareSlider';
import {
    PRIMARY_BUTTON,
    SECONDARY_BUTTON,
    QUIET_BUTTON,
    MICRO_LABEL,
    SHARE_TO_PATIENT_ENABLED,
} from './constants';

const ResultStep = ({ result, onSaveAndSend, onSave, onDiscard }) => (
    <div>
        <div className="mb-4">
            <SmileCompareSlider
                beforeSrc={result.beforeImage}
                afterSrc={result.afterImage}
                maxHeightClassName="max-h-[45vh]"
            />
        </div>

        <div className="flex flex-col gap-2">
            {SHARE_TO_PATIENT_ENABLED && (
                <button type="button" onClick={onSaveAndSend} className={PRIMARY_BUTTON}>
                    <MessageSquare className="w-3.5 h-3.5" />
                    <span className={MICRO_LABEL}>Save &amp; Send to Patient</span>
                </button>
            )}
            {/* Saving is the only action left while sharing is held — take the primary slot. */}
            <button
                type="button"
                onClick={onSave}
                className={SHARE_TO_PATIENT_ENABLED ? SECONDARY_BUTTON : PRIMARY_BUTTON}
            >
                <span className={MICRO_LABEL}>Save to Patient Record</span>
            </button>
            <button type="button" onClick={onDiscard} className={QUIET_BUTTON}>
                Close without saving
            </button>
        </div>
    </div>
);

export default ResultStep;
